import { NotificationTypes } from "redux/actions/notificationAction";

const defaultState = {
  correlationId: null,
	trackingId: null,
	successCount: 0,
	failureCount: 0,
	results: [],
	state: null
};

const notificationReducer = (stateReducer = defaultState, action: any) => {
	const { NotificationResult } = action;
	switch (action.type) {
		case NotificationTypes.SEND_NOTIFICATION:
			return {
				...stateReducer,
			};
		case NotificationTypes.SEND_NOTIFICATION_SUCCESS:
			return {
				...stateReducer,
				results: NotificationResult
			};
	}
	return stateReducer;
};

export default notificationReducer;
